import React from 'react';

import { Banner } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const LinkBanner = ({ $isMobile }) => {
  return (
    <div className='min-w-[280px] tabletH:max-w-[348px] w-full flex flex-col items-start gap-2 pb-4 tabletH:pb-0'>
      <Banner
        type='info'
        size='s'
        label='Show who you are!'
        labelKr='나를 보여 주세요!'
        message='Share links to your websites, portfolios, or profiles.
Let your work speak for your skills and strengths.'
        messageKr={
          '웹사이트, 포트폴리오 또는 프로필 링크를 공유해 주세요.\n여러분의 작업을 통해 역량과 강점을 보여 주세요.'
        }
        hideButton
        hideClose={!$isMobile}
        icon={<IdeaIcon />}
      />
    </div>
  );
};

export default LinkBanner;
